import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import notify from 'devextreme/ui/notify';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { Articoli } from 'src/app/models/articoli';
import {
  DxPopupComponent,
  DxLoadPanelComponent,
  DxButtonComponent,
  DxCheckBoxComponent,
  DxLookupComponent,
} from 'devextreme-angular';

@Component({
  selector: 'app-popup-disattiva-articolo',
  templateUrl: './popup-disattiva-articolo.component.html',
  styleUrls: ['./popup-disattiva-articolo.component.scss'],
  imports: [
    DxPopupComponent,
    DxLoadPanelComponent,
    DxButtonComponent,
    DxCheckBoxComponent,
    DxLookupComponent,
  ],
})
export class PopupDisattivaArticoloComponent implements OnInit {
  private articoliService = inject(ArticoliService);
  @Input() articolo: Articoli;
  @Output() popupDisattivaArticoloEventEmitter = new EventEmitter<boolean>();

  loadPanelVisible = false;
  listArticoli: any;

  idArticoloSostitutivo: number;
  sostituisciConArticolo: boolean = false;

  ngOnInit() {
    this.loadLookups();
  }

  loadLookups() {
    this.articoliService.listTemp().subscribe({
      next: (res) => {
        this.listArticoli = {
          store: {
            type: 'array',
            data: res.filter((a) => a.attivo == true && a.id != this.articolo.id),
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      }
    });
  }

  onEsciClick() {
    this.popupDisattivaArticoloEventEmitter.emit(null);
  }

  onSalvaClick() {
    let idArtSost = 0;
    if (this.sostituisciConArticolo) {
      if (this.idArticoloSostitutivo == 0) {
        notify('Selezionare articolo sostitutivo', 'warning');
        return;
      }
      idArtSost = this.idArticoloSostitutivo;
    }
    this.loadPanelVisible = true;
    this.articoliService
      .disattivaArticolo(this.articolo.id, idArtSost)
      .subscribe({
        next: () => {
          this.articoliService.listTemp(true).subscribe();  
          this.loadPanelVisible = false;
          notify('Articolo disattivato', 'success', 3000);
          this.popupDisattivaArticoloEventEmitter.emit(true);
        },
        error: (error) => {
          this.loadPanelVisible = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore salvataggio dati movimento', 'error', 3000);
          }
        },
      });
  }

  getArticoloDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return (
      item.codice +
      ' - ' +
      item.descrizione +
      (item.taglia ? ' - ' + item.taglia : '')
    );
  }
}
